// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_W7b","cls2":"PaperClaiming-cls2_6eI PaperClaiming-cls1_W7b"};